import { render, staticRenderFns } from "./MasterDetailSelected.vue?vue&type=template&id=3f51d721&scoped=true&"
import script from "./MasterDetailSelected.vue?vue&type=script&lang=js&"
export * from "./MasterDetailSelected.vue?vue&type=script&lang=js&"
import style0 from "./MasterDetailSelected.vue?vue&type=style&index=0&id=3f51d721&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f51d721",
  null
  
)

export default component.exports